import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import adminStockItemsApi from "./api/adminStockItemsApi";
import { AdminInventoryState, AdminStockItemsQuery, AdminStockItemsQueryParameter } from "./models/AdminStockItemsModels";
import customerManufacturersApi from "../customer/shared/api/customerManufacturersApi";
import customerCategoriesApi from "../customer/shared/api/customerCategoriesApi";

export const getStockItems = createAsyncThunk(
  "adminInventory/getStockItems",
  async (query: AdminStockItemsQuery) => {
    return adminStockItemsApi.getStockItems(query);
  }
);

export const getStockItem = createAsyncThunk(
  "adminInventory/getStockItem",
  async (id: string) => {
    return adminStockItemsApi.getStockItem(id);
  }
);

export const changeStockItem = createAsyncThunk(
  "adminInventory/changeStockItem",
  async ({ id, model }: any) => {
    return adminStockItemsApi.changeStockItem(id, model);
  }
);

export const getManufacturers = createAsyncThunk(
  "adminInventory/getManufacturers",
  async () => {
    return customerManufacturersApi.getManufacturers();
  }
);

export const getCategories = createAsyncThunk(
  "adminInventory/getCategories",
  async () => {
    return customerCategoriesApi.getCategories();
  }
);

const initialState: AdminInventoryState = {
  query: {
    search: undefined,
    sortBy: undefined,
    sortDesc: true,
    pageNo: 1,
    pageSize: 20
  },
  stockItems: undefined,
  stockItem: undefined,
  manufacturers: [],
  categories: [],
  loading: false,
  success: undefined,
  error: undefined
};

const adminInventorySlice = createSlice({
  name: "adminInventory",
  initialState: initialState,
  reducers: {
    changeQuery: (state, action) => {
      state.query = action.payload;
    },
    selectStockItem: (state, { payload }) => {
      state.stockItem = payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getStockItems.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStockItems.fulfilled, (state, { payload }) => {
        state.stockItems = payload;
        state.loading = false;
      })
      .addCase(getStockItems.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(getStockItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStockItem.fulfilled, (state, { payload }) => {
        state.stockItem = payload;
        state.loading = false;
      })
      .addCase(getStockItem.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(changeStockItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(changeStockItem.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(changeStockItem.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(getManufacturers.fulfilled, (state, { payload }) => {
        state.manufacturers = payload;
      });

    builder
      .addCase(getCategories.fulfilled, (state, { payload }) => {
        state.categories = payload;
      });
  }
});

export const {
  changeQuery,
  selectStockItem,
  setSuccess,
  setError
} = adminInventorySlice.actions;

export default adminInventorySlice.reducer;